import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Reusable/Shared';
import TextAreaField from '../../shared/Fields/TextAreaField';

const MAX_CHARACTERS = 4096;

interface AddInstructionsProps {
  onSave: (instructions: string) => void;
  onClose: () => void;
  initialInstructions?: string;
  placeholder: string;
}

const AddInstructions: React.FC<AddInstructionsProps> = ({
  onSave,
  onClose,
  initialInstructions = '',
  placeholder = ''
}) => {
  const [instructions, setInstructions] = useState<any>({ instructions: initialInstructions });
  const [instructionsError, setInstructionsError] = useState<any>({
    instructions: ''
  });
  const { t } = useTranslation();

  const handleInstructionsChange = (value: any) => {
    const newValue = value.instructions;
    setInstructions({ instructions: newValue });

    if (newValue.length > MAX_CHARACTERS) {
      setInstructionsError({
        instructions: `${t('T_VALIDATION_ERR_TEXT_LENGTH_CUSTOM_MSG').replace(
          '${LENGTH}',
          MAX_CHARACTERS.toString()
        )}`
      });
    } else {
      setInstructionsError({ instructions: '' });
    }
  };

  const characterCount = instructions.instructions.length || 0;

  return (
    <div className="w-full p-4">
      <div className="flex w-full flex-col space-y-4">
        <TextAreaField
          fieldKey={'instructions'}
          type={'text'}
          id={'instructions'}
          label={placeholder}
          placeholder={''}
          required={false}
          formData={instructions}
          setFormData={handleInstructionsChange}
          formError={instructionsError}
          asterixFirst
          rows={10}
          disabled={false}
        ></TextAreaField>
        <div className="text-sm text-gray-500">
          {characterCount}/{MAX_CHARACTERS} {t('T_CHARACTERS')}
        </div>
      </div>

      <div className="mt-6 flex justify-end space-x-4">
        <Button
          color={'secondary'}
          width={'100px'}
          onClick={onClose}
          disabled={false}
          classes="text-ellipsis overflow-hidden"
          id={'secondary-button'}
        >
          {t('T_CANCEL')}
        </Button>

        <Button
          color={'primary'}
          width={'100px'}
          onClick={() => onSave(instructions.instructions)}
          disabled={
            characterCount === 0 ||
            characterCount > MAX_CHARACTERS ||
            initialInstructions === instructions.instructions
          }
          classes="text-ellipsis overflow-hidden"
          id={'primary-button'}
        >
          {t('T_SAVE')}
        </Button>
      </div>
    </div>
  );
};

export default AddInstructions;
